module.exports = __webpack_public_path__ + "1698e29d1bed23602d68b63c2b8dccd2.svg";